import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=dc30c82a&"
import script from "./AddProduct.vue?vue&type=script&lang=ts&"
export * from "./AddProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports